import React from 'react';
import ProgrammePageRenderer from '../components/ProgrammePageRenderer';

const seatToken = {
  hero: { section_key: 'hero', section_type: 'hero', image: '/images/page-banners/middle-programme.webp' },
  intro: {
    section_key: 'intro',
    section_type: 'intro',
    kicker: 'Middle School Programme',
    title: 'Evolving the Perspective and Experience Palette',
    image: '/images/our-program/middle-1.webp',
    description:
      'The formative years of education are Middle School, where either you fall in love with learning or you do not. As educators, it is crucial to design the curriculum in a way that makes learning fun and interesting.\n\nAt St. Andrews World School, the Middle School Programme inculcates a positive attitude toward learning. We aim to create the right balance between concepts and experiences for effective learning.\n\nWe help students build disciplinary habits of proper planning and execution, and we bring subject expertise into the classroom while equally involving practical on-field experiences.',
  },
  themes_header: {
    section_key: 'themes_header',
    section_type: 'header',
    kicker: 'What the Programme Builds',
    title: 'Learning Beyond the Classroom',
    extra: { bg: 'light' },
  },
  card_1: {
    section_key: 'card_1',
    section_type: 'card',
    icon: 'fa-people-group',
    title: 'Community Engagement',
    description:
      "Real-life projects and community service help students connect learning with society. Experiential tasks require learners to observe, analyse, reflect and understand concepts deeply, evolving their voices and perspectives on social, cultural and ecological issues.",
  },
  card_2: {
    section_key: 'card_2',
    section_type: 'card',
    icon: 'fa-desktop',
    title: 'Interdisciplinary Learning',
    description:
      'The curriculum is interdisciplinary, with content and skills interwoven through each subject. A combined delivery approach moves beyond mundane subject curricula and involves experiences that compel students to become completely involved.',
  },
  card_3: {
    section_key: 'card_3',
    section_type: 'card',
    icon: 'fa-bullseye',
    title: 'Organisation & Discipline',
    description:
      'Students build disciplined habits of proper planning and execution. Through the structure of the programme, they learn to manage tasks, stay organised and take ownership of their learning journey.',
  },
  card_4: {
    section_key: 'card_4',
    section_type: 'card',
    icon: 'fa-lightbulb',
    title: 'Expert-Guided Experiences',
    description:
      'Subject expertise is brought into the classroom to build engaging learning experiences, equally balanced with practical on-field exposure. The Middle School Programme helps students achieve both academic excellence and personality development.',
  },
  values_navy: {
    section_key: 'values_navy',
    section_type: 'navy',
    kicker: 'What We Foster',
    title: 'Voicing Perspectives, Driving Change',
    extra: { footer: 'Empowering students to think about social, cultural and ecological issues leads them to be motivated toward bringing meaningful societal change.' },
  },
  navy_card_1: { section_key: 'navy_card_1', section_type: 'navy_card', icon: 'fa-face-smile', title: 'Positive attitude toward learning' },
  navy_card_2: { section_key: 'navy_card_2', section_type: 'navy_card', icon: 'fa-scale-balanced', title: 'Balance of concepts and experience' },
  navy_card_3: { section_key: 'navy_card_3', section_type: 'navy_card', icon: 'fa-earth-asia', title: 'Awareness of community issues' },
  navy_card_4: { section_key: 'navy_card_4', section_type: 'navy_card', icon: 'fa-hand-holding-heart', title: 'Motivation for societal change' },
  outcome: {
    section_key: 'outcome',
    section_type: 'outcome',
    kicker: 'The Middle Journey',
    title: 'From Interest to Mastery',
    image: '/images/our-program/middle-2.webp',
    description:
      'The Middle School Programme helps the students achieve academic excellence and personality development, preparing them to fall in love with learning for life.',
  },
  cta: {
    section_key: 'cta',
    section_type: 'cta',
    icon: 'fa-comment-dots',
    title: 'Beyond the Classroom. Ready for the World.',
    description: 'Discover the Middle School Programme of St. Andrews World School, Indirapuram.',
    button_text: 'Explore Our Programmes',
    button_url: '/our-programmes',
    button2_text: 'Enquire for Admission',
    button2_url: '/admission',
  },
};

const DEFAULT_SECTIONS = [
  seatToken.hero,
  seatToken.intro,
  seatToken.themes_header,
  seatToken.card_1,
  seatToken.card_2,
  seatToken.card_3,
  seatToken.card_4,
  seatToken.values_navy,
  seatToken.navy_card_1,
  seatToken.navy_card_2,
  seatToken.navy_card_3,
  seatToken.navy_card_4,
  seatToken.outcome,
  seatToken.cta,
];

const seo = {
  title: 'Middle School Programme',
  description: 'Evolving the perspective and experience palette — the Middle School Programme (Grades 6–8) at St. Andrews World School, Indirapuram.',
  keywords: 'Middle School Programme, ICSE school Indirapuram, St Andrews World School, Grades 6 to 8',
};

const MiddleSchoolProgrammePage = () => (
  <ProgrammePageRenderer pageKey="middle" defaults={DEFAULT_SECTIONS} seo={seo} />
);

export default MiddleSchoolProgrammePage;